
type ImageDimensions = {
  [key: string]: { width: number; height: number };
};

// Define standard dimensions for common images
const imageDimensions: ImageDimensions = {
  "/lovable-uploads/00525eb1-861d-450e-aded-1102c0cae4e7.png": { width: 120, height: 40 }, // Logo
  "/lovable-uploads/a069036b-4ea0-488d-a6ec-93481bc15267.png": { width: 80, height: 80 }, // Savita's profile photo
  "/lovable-uploads/7d1ccd03-2690-4a11-9f91-d42bb6d5a308.png": { width: 80, height: 32 }, // Fractal
  "/lovable-uploads/68024710-3e67-4a2b-866d-21d0cd49b4b0.png": { width: 100, height: 32 }, // Shiprocket
  "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png": { width: 80, height: 32 }, // Sprinto
  "/lovable-uploads/f0e559de-57be-429d-8fc3-fdb35842aa81.png": { width: 100, height: 32 }, // StepSecurity
  "/lovable-uploads/656a10f9-d525-4884-adc1-7910d6b9b235.png": { width: 100, height: 40 }, // Success story logos
  "/lovable-uploads/d6cd13f0-746b-497b-8a48-da1b0b3359c9.png": { width: 100, height: 40 },
  "/lovable-uploads/7c7137df-389b-48c9-91c1-10bd139e59d4.png": { width: 100, height: 40 },
  "/lovable-uploads/caaef211-6b5e-41ee-a6ef-7992a73828c1.png": { width: 100, height: 40 },
  // ATS Integration images
  "/lovable-uploads/b9f59f33-f60a-4ded-a2e3-767fad897572.png": { width: 100, height: 60 },
  "/lovable-uploads/245f2fc5-e454-4b26-bdd2-f16beaf60078.png": { width: 100, height: 60 },
  "/lovable-uploads/92ed36c6-9478-4a3b-b64e-390deb7157fd.png": { width: 100, height: 60 },
  "/lovable-uploads/81813598-505c-4f69-8e4f-a4b49a2bc13f.png": { width: 100, height: 60 },
  "/lovable-uploads/f1f47a52-2434-4282-b229-45e37b8b3572.png": { width: 100, height: 60 },
  "/lovable-uploads/d9d718f7-efd6-4b3b-86af-cec4ddbf3697.png": { width: 100, height: 60 },
  "/lovable-uploads/cf0f7add-a299-4fad-a842-0c1470ec3b6c.png": { width: 100, height: 60 },
};

export const getImageDimensions = (src: string) => {
  return imageDimensions[src] || { width: 100, height: 100 };
};

export const optimizedImage = (src: string, altText: string, className: string = "", loading: "eager" | "lazy" = "lazy") => {
  const { width, height } = getImageDimensions(src);
  
  return {
    src,
    alt: altText,
    className,
    width,
    height,
    loading,
    onError: (e: React.SyntheticEvent<HTMLImageElement>) => {
      const target = e.target as HTMLImageElement;
      target.onerror = null;
      target.src = '/placeholder.svg';
    }
  };
};
